import Vue from 'vue'

export default {
    state: {

    },

    getters: {

    },

    actions: {
        setPagination(context, params) {
            context.commit('setPagination', { tableId: params.tableId, page: params.page, sortBy: params.sortBy, descending: params.descending })
        },
        setSelected(context, params) {
            context.commit('setSelected', { tableId: params.tableId, selected: params.selected })
        },
        clearSelected(context, params) {
            context.commit('clearSelected', { tableId: params.tableId })
        },
    },

    mutations: {
        setPagination(state, event) {
            if(!state[event.tableId]) {
                state[event.tableId] = {}
            }

            state[event.tableId].page        = event.page
            state[event.tableId].sortBy      = event.sortBy
            state[event.tableId].descending  = event.descending
        },
        setSelected(state, event) {
            if(!state[event.tableId]) {
                state[event.tableId] = {}
            }

            state[event.tableId].selected = event.selected
        },
        clearSelected(state, event) {
            if(state[event.tableId]) {
                state[event.tableId].selected = []
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/datatable.js